module.exports = __webpack_public_path__ + "img/app-key-screenshots.3333254a.jpg";